document.addEventListener("DOMContentLoaded", function () {
  if (!window.theme?.settings?.enable_pinterest_button) return;

  const iconURL = 'https://cdn.shopify.com/s/files/1/0606/5550/1474/files/pinterest.svg?v=1746426589';
  const isMobile = window.innerWidth <= 1024;

  function addPinterestButton(container) {
    const img = container.querySelector('img');
    if (!img) return;
    if (container.querySelector('.pinit-wrapper-custom')) return;

    const waitForImage = setInterval(() => {
      const src = img.currentSrc || img.src;
      if (src && src.startsWith('http') && img.naturalWidth) {
        clearInterval(waitForImage);

        container.querySelectorAll('.pinit-wrapper, .pinit-wrapper-custom').forEach(el => el.remove());

        const wrapper = document.createElement('div');
        wrapper.className = 'pinit-wrapper-custom';
        wrapper.style.position = 'absolute';
        wrapper.style.top = '12px';
        wrapper.style.zIndex = isMobile ? '9' : '9999';
        wrapper.style.opacity = isMobile ? '0.8' : '0';
        wrapper.style.transition = isMobile ? 'none' : 'opacity 0.3s ease';
        wrapper.style.pointerEvents = isMobile ? 'none' : 'auto';

        const screenWidth = window.innerWidth;
        const isMagazine = container.querySelector('a[href*="/collections/magazines"]');
        const isPortrait = img.naturalHeight > img.naturalWidth;

        // Default right offset
        let offsetRight = isMobile ? '6px' : '6px';

        if (isMagazine) {
          if (screenWidth < 780) {
            offsetRight = '0px';
          } else if (screenWidth <= 1024) {
            offsetRight = '-12px';
          } else if (screenWidth > 1024) {
            offsetRight = '-18px';
          }
        } else if (isPortrait && screenWidth <= 1024) {
          offsetRight = '40px';
        } else if (isPortrait && screenWidth > 1024) {
          offsetRight = '16px';
        }

        wrapper.style.right = offsetRight;

        const pin = document.createElement('a');
        pin.href = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}&media=${encodeURIComponent(src)}&description=${img.alt || ''}`;
        pin.target = '_blank';
        pin.rel = 'noopener noreferrer';

        const icon = document.createElement('img');
        icon.src = iconURL;
        icon.alt = 'Pin it';
        icon.style.width = isMobile ? '28px' : '36px';
        icon.style.height = isMobile ? '28px' : '36px';
        icon.style.cursor = 'pointer';
        icon.style.borderRadius = '50%';

        pin.appendChild(icon);
        wrapper.appendChild(pin);

        container.style.position = 'relative';
        container.appendChild(wrapper);

        if (!isMobile) {
          container.addEventListener('mouseenter', () => (wrapper.style.opacity = '1'));
          container.addEventListener('mouseleave', () => (wrapper.style.opacity = '0'));
        }
      }
    }, 300);
  }

  document.querySelectorAll('.custom-product-one-media, .t4s-product-inner, .t4s-product-card-media')
    .forEach(addPinterestButton);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('.custom-product-one-media, .t4s-product-inner, .t4s-product-card-media')) {
          addPinterestButton(node);
        } else {
          node.querySelectorAll?.('.custom-product-one-media, .t4s-product-inner, .t4s-product-card-media')
            .forEach(addPinterestButton);
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
